import styled from 'styled-components'

import { FONTS, COLORS } from '../../constants'

const ModalHeader = styled.p`
  margin: 0px;

  position: relative;
  top: 4px;

  color: ${COLORS.PRIMARY_RED};
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  font-size: ${FONTS.TITLE_SIZE};
`

export default ModalHeader



// WEBPACK FOOTER //
// ./src/lib/typography/ModalHeader.jsx